@if (codes().length > 0) {
  <!-- Desktop view -->
  <div class="hidden rounded border border-slate-200 lg:block lg:px-2">
    <table class="w-full table-auto border-collapse">
      <thead class="bg-surface-100 border-surface-200 border-b drop-shadow-sm">
        <tr>
          <th class="truncate whitespace-nowrap px-2 py-4 text-left text-sm font-normal text-slate-500" [attr.title]="'codes.note' | transloco">
            {{ 'codes.note' | transloco }}
          </th>
          <th class="truncate whitespace-nowrap px-2 py-4 text-left text-sm font-normal text-slate-500" [attr.title]="'codes.device' | transloco">
            {{ 'codes.device' | transloco }}
          </th>
          <th class="truncate whitespace-nowrap px-2 py-4 text-left text-sm font-normal text-slate-500" [attr.title]="'codes.activated' | transloco">
            {{ 'codes.activated' | transloco }}
          </th>
          <th class="truncate whitespace-nowrap px-2 py-4 text-left text-sm font-normal text-slate-500" [attr.title]="'codes.lastSeen' | transloco">
            {{ 'codes.lastSeen' | transloco }}
          </th>
          <th class="truncate whitespace-nowrap px-2 py-4 text-left text-sm font-normal text-slate-500" [attr.title]="'codes.code' | transloco">
            {{ 'codes.code' | transloco }}
          </th>
          <th class="truncate whitespace-nowrap px-2 py-4 text-left text-sm font-normal text-slate-500" [attr.title]="'codes.validity' | transloco">
            {{ 'codes.validity' | transloco }}
          </th>
          <th class="truncate whitespace-nowrap px-2 py-4 text-left text-sm font-normal text-slate-500" [attr.title]="'codes.action' | transloco">
            {{ 'codes.action' | transloco }}
          </th>
        </tr>
      </thead>
      <tbody>
        @for (code of codes(); track code._id) {
          <tr
            class="border-surface-200 hover:bg-surface-50 border-b transition-colors last:border-b-0"
            [class.bg-yellow-100]="highlightedCodeId() === code._id"
            [class.ring-2]="highlightedCodeId() === code._id"
            [class.ring-yellow-400]="highlightedCodeId() === code._id"
            [class.animate-pulse]="highlightedCodeId() === code._id">
            <td class="max-w-[100px] overflow-hidden px-2 py-2 text-sm" [attr.title]="code.note || ('codes.noNote' | transloco)">
              {{ code.note || ('codes.noNote' | transloco) }}
            </td>
            <td class="max-w-[200px] overflow-hidden px-2 py-2 text-sm" [attr.title]="code.usedByDevice || '-'">
              {{ code.usedByDevice || '-' }}
            </td>
            <td class="truncate px-2 py-2 text-sm">
              {{ displayActivatedAtColumn(code.createdAt) }}
            </td>
            <td class="truncate px-2 py-2 text-sm">
              {{ displayUsedAtColumn(code.usedAt) }}
            </td>
            <td class="px-2 py-2 text-sm">
              @if (getCodeStatus(code) === 'active') {
                <div [attr.data-tippy-content]="'codes.copyTooltip' | transloco" class="inline-block">
                  <p-button
                    icon="pi pi-copy"
                    severity="contrast"
                    size="small"
                    [outlined]="false"
                    [rounded]="true"
                    [label]="code.code"
                    (click)="copyCodeToClipboard.emit({ code: code.code, event: $event })"
                    data-testid="device-code"></p-button>
                </div>
              } @else {
                <div [attr.data-tippy-content]="'codes.copyNotAllowed' | transloco" class="inline-block">
                  <p-button
                    icon="pi pi-copy"
                    severity="contrast"
                    size="small"
                    [outlined]="true"
                    [rounded]="true"
                    [label]="code.code"
                    [disabled]="true"
                    styleClass="!cursor-not-allowed !opacity-50"></p-button>
                </div>
              }
            </td>
            <td class="truncate px-2 py-2 text-sm">
              @if (code.usedAt) {
                <span class="text-gray-500">{{ 'codes.expired' | transloco }}</span>
              } @else {
                {{ displayExpiresAtColumn(code.createdAt) }}
              }
            </td>
            <td class="w-[150px] px-2 py-4">
              <div class="flex max-w-full items-center gap-2 overflow-hidden">
                @if (getCodeStatus(code) === 'logged-out') {
                  <p-button
                    disabled="true"
                    severity="secondary"
                    variant="outlined"
                    size="small"
                    class="flex-1 overflow-hidden"
                    styleClass="truncate max-w-full !block w-full !cursor-not-allowed">
                    {{ 'codes.status.logged-out' | transloco }}
                  </p-button>
                } @else if (getCodeStatus(code) === 'active') {
                  <p-button
                    [label]="getActionButtonLabel(code)"
                    severity="help"
                    size="small"
                    class="flex-1 overflow-hidden"
                    styleClass="truncate max-w-full !block w-full"
                    (click)="handleCodeAction.emit(code)"></p-button>
                } @else {
                  <p-button
                    [label]="getActionButtonLabel(code)"
                    severity="info"
                    size="small"
                    class="flex-1 overflow-hidden"
                    styleClass="truncate max-w-full !block w-full"
                    (click)="handleCodeAction.emit(code)"></p-button>
                }

                @if (getCodeStatus(code) !== 'logged-out') {
                  <p-button
                    [disabled]="true"
                    icon="pi pi-trash"
                    severity="contrast"
                    variant="outlined"
                    size="small"
                    class="opacity-50"
                    styleClass="!cursor-not-allowed"></p-button>
                } @else {
                  <p-button
                    icon="pi pi-trash"
                    (click)="handleCodeAction.emit(code)"
                    severity="contrast"
                    variant="outlined"
                    size="small"
                    [attr.data-tippy-content]="'codes.delete' | transloco"></p-button>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Mobile view -->
  <div class="flex flex-col gap-4 lg:hidden">
    @for (code of codes(); track code._id) {
      <div
        class="overflow-hidden rounded-lg border border-slate-200 transition-all"
        [class.bg-yellow-50]="highlightedCodeId() === code._id"
        [class.ring-2]="highlightedCodeId() === code._id"
        [class.ring-yellow-400]="highlightedCodeId() === code._id"
        [class.animate-pulse]="highlightedCodeId() === code._id">
        <div
          class="flex items-start justify-between gap-4 p-4"
          [class.bg-green-100]="getCodeStatus(code) === 'active'"
          [class.bg-blue-100]="getCodeStatus(code) === 'used'"
          [class.bg-red-100]="getCodeStatus(code) === 'expired'"
          [class.bg-gray-100]="getCodeStatus(code) === 'logged-out'">
          <div class="flex-1 text-base font-semibold">
            {{ code.note || ('codes.noNote' | transloco) }}
          </div>
          <div
            class="whitespace-nowrap rounded-xl border px-3 py-1 text-xs font-semibold"
            [ngClass]="{
              'border-green-800 text-green-800': getCodeStatus(code) === 'active',
              'border-blue-800 text-blue-800': getCodeStatus(code) === 'used',
              'border-red-800 text-red-800': getCodeStatus(code) === 'expired',
              'border-gray-800 text-gray-800': getCodeStatus(code) === 'logged-out',
            }">
            {{ 'codes.status.' + getCodeStatus(code) | transloco }}
          </div>
        </div>

        <div class="mt-4 flex flex-col gap-2 px-4">
          <div class="flex gap-4 text-sm">
            <div class="w-32 font-medium text-slate-700">{{ 'codes.device' | transloco }}:</div>
            <div class="flex-1">{{ code.usedByDevice || '-' }}</div>
          </div>

          <div class="flex gap-4 text-sm">
            <div class="w-32 font-medium text-slate-700">{{ 'codes.activated' | transloco }}:</div>
            <div class="flex-1">{{ displayActivatedAtColumn(code.createdAt) }}</div>
          </div>

          <div class="flex gap-4 text-sm">
            <div class="w-32 font-medium text-slate-700">{{ 'codes.lastSeen' | transloco }}:</div>
            <div class="flex-1">{{ displayUsedAtColumn(code.usedAt) }}</div>
          </div>

          <div class="flex gap-4 text-sm">
            <div class="w-32 font-medium text-slate-700">{{ 'codes.code' | transloco }}:</div>
            @if (getCodeStatus(code) === 'active') {
              <p-button
                icon="pi pi-copy"
                severity="contrast"
                size="small"
                [outlined]="false"
                [rounded]="true"
                [label]="code.code"
                (click)="copyCodeToClipboard.emit({ code: code.code, event: $event })"></p-button>
            } @else {
              <p-button
                icon="pi pi-copy"
                severity="contrast"
                size="small"
                [outlined]="true"
                [rounded]="true"
                [label]="code.code"
                [disabled]="true"
                styleClass="!cursor-not-allowed !opacity-50"></p-button>
            }
          </div>

          <div class="flex gap-4 text-sm">
            <div class="w-32 font-medium text-slate-700">{{ 'codes.validity' | transloco }}:</div>
            <div class="flex-1">
              @if (code.usedAt) {
                <span class="text-gray-500">{{ 'codes.expired' | transloco }}</span>
              } @else {
                {{ displayExpiresAtColumn(code.createdAt) }}
              }
            </div>
          </div>
        </div>

        <div class="flex items-center justify-end gap-2 overflow-hidden p-4">
          @if (getCodeStatus(code) === 'logged-out') {
            <p-button disabled="true" severity="secondary" variant="outlined" size="small" class="" styleClass="!block !cursor-not-allowed">
              {{ 'codes.status.logged-out' | transloco }}
            </p-button>
          } @else if (getCodeStatus(code) === 'active') {
            <p-button
              [label]="getActionButtonLabel(code)"
              severity="help"
              size="small"
              class=""
              styleClass="!block"
              (click)="handleCodeAction.emit(code)"></p-button>
          } @else {
            <p-button
              [label]="getActionButtonLabel(code)"
              severity="info"
              size="small"
              class=""
              styleClass="!block"
              (click)="handleCodeAction.emit(code)"></p-button>
          }

          @if (getCodeStatus(code) !== 'logged-out') {
            <p-button
              [disabled]="true"
              icon="pi pi-trash"
              severity="contrast"
              variant="outlined"
              size="small"
              class="opacity-50"
              styleClass="!cursor-not-allowed"></p-button>
          } @else {
            <p-button
              icon="pi pi-trash"
              (click)="handleCodeAction.emit(code)"
              severity="contrast"
              variant="outlined"
              size="small"
              [attr.data-tippy-content]="'codes.delete' | transloco"></p-button>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <div class="rounded border border-slate-200 p-8 text-center text-slate-600">
    <i class="pi pi-inbox text-5xl"></i>
    <p class="">{{ 'codes.noCodes' | transloco }}</p>
  </div>
}
